import React, { FC } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import { ROUTES } from "../../routes";
import { selectCurrentUser } from "../../store/reducers/user";
import { AccountType } from "../../types/UserTypes";

export const HomePage: FC = () => {
  const location = useLocation();
  const { state } = location;
  const queryParams = location.search ? `${location.search}` : "";
  const { id, is_onmeta_eligible, account_type } =
    useSelector(selectCurrentUser);

  if (!id) {
    return (
      <Navigate
        to={`${ROUTES.AUTH_LOGIN}${queryParams}`}
        state={{ ...state }}
      />
    );
  }

  if (is_onmeta_eligible && account_type === AccountType.CONTRACTOR) {
    return (
      <Navigate
        to={`${ROUTES.PAYMENT_REQUESTS}${queryParams}`}
        state={{ ...state }}
      />
    );
  }

  return (
    <Navigate to={`${ROUTES.RECEIVE}${queryParams}`} state={{ ...state }} />
  );
};
